import React from 'react';
import { Routes, Route } from 'react-router-dom';
import NemwelPhoto from '../images/NemwelAbout.jpg';
import AboutMeNav from './AboutMeRoutes/AboutMeNav';
import NemwelBio from './AboutMeRoutes/Bio';
import NemwelEducation from './AboutMeRoutes/Education';
import NemwelExperiences from './AboutMeRoutes/Experience';

const AboutMe = () => (
  <div id="AboutMe" className="AboutMe">
    <div className="sectionHeading">
      <div className="sectionLeftHeading">
        <h3 className="headingPinked">About Me</h3>
        <h2>Who is Nemwel?</h2>
      </div>
      <div className="sectionRightMoreDetails" />
    </div>

    <div className="AboutMeBody">
      <div className="left">
        <img src={NemwelPhoto} alt="Nemwel Boniface — About Me" />
      </div>
      <div className="right">
        <AboutMeNav />
        <Routes>
          <Route path="/" element={<NemwelBio />} />
          <Route path="/education" element={<NemwelEducation />} />
          <Route path="/experience" element={<NemwelExperiences />} />
        </Routes>
      </div>
    </div>
  </div>
);

export default AboutMe;
